<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>Luis Lasso de la Vega publica el Huei Tlamahuicoltica (1649)</h2>
    <img @click="imageClicked(0)" src="galerias/guadalupe/g4/G4.jpg" class="mainphoto"/>
    <p class="photo-description">Portada de la publicación del “Huei Tlamahuiçoltica” (El Gran Acontecimiento).</p>
    <p>Luis Lasso de la Vega, sacerdote criollo de Nueva España, fue cura vicario y capellán de la ermita de Nuestra Señora de Guadalupe. Publicó un relato en náhuatl de la historia de las apariciones de la Virgen de Guadalupe, en el cerro del Tepeyac, al indio Juan Diego, entre el 9 y el 12 de diciembre de 1531.</p>
    <p>El manuscrito original del libro impreso en 1649 se ha localizado, está escrito en tinta verde signado en 1646 (por tanto anterior a la obra de Miguel Sánchez de 1648) y cuyo título completo es: “Huei Tlamahuiçoltica omonexiti in ilhvicac tlatoca çihuapilli Santa María, totlaçonantzin Guadalupe in nican hvei altepenahvac Mexico itocoyocan Tepeyacac” (Se apareció maravillosamente la Reina del Cielo Santa María, nuestra amada Madre de Guadalupe aquí cerca de la Ciudad de México en el lugar nombrado Tepeyácac).</p>
    <h5>VER MÁS</h5>
    <p>
      <ul>
        <li><a target="_blank" href="http://bdmx.mx/documento/santa-maria-nuestra-madre-guadalupe">bdmx.mx</a></li>
        <li><a target="_blank" href="https://dhial.org/diccionario/index.php?title=HUEI_TLAMAHUIZOLTICA">dhial.org</a></li>
        <li><a target="_blank" href="https://www.wdl.org/es/item/2966/">www.wdl.org</a></li>
      </ul>
    </p>

    <h4>Miguel Sánchez publicó la Imagen de la Virgen de Guadalupe (1649)</h4>
    <img @click="imageClicked(1)" class="mainphoto" src="galerias/guadalupe/g4/G4_A.jpg"/>
    <p>Miguel Sánchez, nacido en Puebla, estudió en la Real y Pontificia Universidad de México donde obtuvo el grado de Bachiller. Publicó en castellano “La Imagen de la Virgen María Madre de Dios de Guadalupe, milagrosamente aparecida en la Ciudad de México. Celebrada en su historia, con la profecía del capítulo doce del Apocalipsis”. 1648.</p>
    <p>Es la primera obra narrativa impresa sobre el Acontecimiento Guadalupano, las anteriores fueron obras manuscritas. En ella, la Virgen de Guadalupe se vincula con las referencias de la mujer del Apocalipsis 12: “una mujer vestida del sol, con la luna debajo de sus pies, y sobre su cabeza una corona de doce estrellas.”</p>
    <p>En la imagen se muestra la portada de la publicación de Miguel Sánchez, “Imagen de la Virgen María Madre de Dios de Guadalupe, milagrosamente aparecida en la Ciudad de México. Celebrada en su historia, con la profecía del capítulo doce del Apocalipsis” 1648.</p>
    <p>Si deseas conocer más:
      <ul>
        <li><a target="_blank" href="https://bvpb.mcu.es/es/consulta/registro.do?id=397517">bvpb.mcu.es</a></li>
        <li><a target="_blank" href="http://www.cervantesvirtual.com/obra/imagen-de-la-virgen-maria-madre-de-dios-de-gvadalupe-milagrosamente-aparecida-en-la-ciudad-de-mexico/">www.cervantesvirtual.com</a></li>
      </ul>
    </p>
    
    <h4>Las Informaciones jurídicas de 1666</h4>
    <img @click="imageClicked(2)" class="mainphoto" src="galerias/guadalupe/g4/G4_B.jpg"/>
    <p class="photo-description">Informaciones Guadalupanas de 1666. Autor: José María Ibarrarán y Ponce. Óleo sobre tela, siglo XIX. Col. Museo José Luis Bello y Zetina, Puebla.</p>
    <p>Las informaciones jurídicas de 1666 plantearon el registro de una serie de testimonios del Acontecimiento Guadalupano, a petición de la Congregación de Ritos de Roma, sobre el interés del Cabildo catedralicio de la Arquidiócesis de México de lograr fiesta y misa propia para la Virgen de Guadalupe trasladando así la fecha mariana habitual del 8 de septiembre al 12 de diciembre. El registro de dicha tradición oral  estuvo realizada con rigor tomando testimonio a herederos confiables que directamente habían tenido información de dichos hechos.</p>
    <p>En la imagen se aprecia una representación de este momento de la historia.</p>
    <p>Si deseas conocer más:
      <ul>
        <li>
          <a target="_blank" href="https://www.dhial.org/diccionario/index.php?title=GUADALUPE;_Informaciones_jur%C3%ADdicas_de_1666#:~:text=Las%20Informaciones%20Jur%C3%ADdicas%20de%201666,y%20su%20fama%20de%20santidad">
            www.dhial.org
          </a>
        </li>
        <li><a target="_blank" href="http://www.museobello.org/pintura.php">www.museobello.org</a></li>
      </ul>
    </p>
  </div>
</template>

<script>
export default {
  name: "Sala2m3",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    }
  },
  components: {},
  props: {},
  mounted() {},
};
</script>
